import { dispatchTrackingEventGA4 } from 'common/tracking/dispatchTrackingEventGA4';
import { Element } from 'common/types/tracking';

export type DrawerType = 'item' | 'order';

const enum EVENT_PLACEMENT {
  HelpSectionContainer = 'help-section-container',
  ItemDrawer = 'item-drawer',
  OrderDrawer = 'order-drawer',
}

const enum EVENT_INTERACTION {
  Close = 'close',
  Select = 'select',
  Submit = 'submit',
  Login = 'login',
  OpenItemDrawer = 'open_item_drawer',
  OpenOrderDrawer = 'open_order_drawer',
}

const CLICK_EVENT = 'contact-form_click';

const getPlacementForDrawerType = (type: DrawerType) =>
  type === 'item' ? EVENT_PLACEMENT.ItemDrawer : EVENT_PLACEMENT.OrderDrawer;

const getInteractionForDrawerType = (type: DrawerType) =>
  type === 'item' ? EVENT_INTERACTION.OpenItemDrawer : EVENT_INTERACTION.OpenOrderDrawer;

export const reasonSelectionTrackingEvent = (reason: string, buttonLabel: string) =>
  dispatchTrackingEventGA4({
    event: CLICK_EVENT,
    element: Element.Button,
    button_text: buttonLabel,
    label: reason,
  });

export const helpLinkTrackingEvent = (reason: string, linkText: string) =>
  dispatchTrackingEventGA4({
    event: CLICK_EVENT,
    element: Element.Link,
    placement: EVENT_PLACEMENT.HelpSectionContainer,
    link_text: linkText,
    label: reason,
  });

export const loginLinkTrackingEvent = (reason: string, linkText: string) =>
  dispatchTrackingEventGA4({
    event: CLICK_EVENT,
    interaction: EVENT_INTERACTION.Login,
    element: Element.Link,
    link_text: linkText,
    label: reason,
  });

export const formSubmitTrackingEvent = (reason: string, buttonLabel: string) =>
  dispatchTrackingEventGA4({
    event: CLICK_EVENT,
    element: Element.Button,
    button_text: buttonLabel,
    interaction: EVENT_INTERACTION.Submit,
    label: reason,
  });

export const openDrawerTrackingEvent = (reason: string, type: DrawerType) =>
  dispatchTrackingEventGA4({
    event: CLICK_EVENT,
    element: Element.InputWrapper,
    interaction: getInteractionForDrawerType(type),
    label: reason,
  });

export const selectDrawerContentTrackingEvent = (reason: string, type: DrawerType) =>
  dispatchTrackingEventGA4({
    event: CLICK_EVENT,
    placement: getPlacementForDrawerType(type),
    element: Element.Button,
    interaction: EVENT_INTERACTION.Select,
    label: reason,
  });

export const closeDrawerTrackingEvent = (reason: string, element: Element, type: DrawerType) =>
  dispatchTrackingEventGA4({
    event: CLICK_EVENT,
    placement: getPlacementForDrawerType(type),
    element,
    interaction: EVENT_INTERACTION.Close,
    label: reason,
  });
